export const getDomainUrl = (link: string) => {
  const defaultDomainUrl = process.env.NEXT_PUBLIC_API_URL;

  if (link.startsWith(defaultDomainUrl!)) {
    return link;
  }

  return defaultDomainUrl + link;
};
